import { render, staticRenderFns } from "./StaticLinkColumn.vue?vue&type=template&id=7915d4ca&"
import script from "./StaticLinkColumn.vue?vue&type=script&lang=ts&"
export * from "./StaticLinkColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports